import Datatable from "./datatable_controller";

// Connects to data-controller="waitlist-datatable"
export default class extends Datatable {
  get columns() {
    return [
      { data: "date" },
      { data: "full_name" },
      { data: "email" },
      { data: "ticket_type" },
      { data: "quantity" },
      { data: "waitlist_type" },
      { data: "status" },
    ];
  }

  get searching() {
    return true;
  }

  get ordering() {
    return true;
  }

  get lengthChange() {
    return false;
  }
}
